import { call, put, takeLatest } from 'redux-saga/effects'

import * as service from 'checkout/services/coupon'

import { Constants, Actions } from './'

function * applyCoupon ({ code }) {
  try {
    const { data } = yield call(service.applyCoupon, code)
    yield put(Actions.applyCouponSuccess(data))
  } catch ({ status }) {
    yield put(Actions.applyCouponFailure(status))
  }
}

function * removeCoupon ({ code }) {
  try {
    const { data } = yield call(service.removeCoupon, code)
    yield put(Actions.removeCouponSuccess(data))
  } catch ({ status }) {
    yield put(Actions.removeCouponFailure(status))
  }
}

function * updatePage () {
  document.dispatchEvent(new Event('updatePage'))
}

export default function * root () {
  yield takeLatest(Constants.COUPONS_APPLY, applyCoupon)
  yield takeLatest(Constants.COUPONS_REMOVE, removeCoupon)

  yield takeLatest(Constants.COUPONS_APPLY_SUCCESS, updatePage)
  yield takeLatest(Constants.COUPONS_REMOVE_SUCCESS, updatePage)
}
